import * as ImSdk from "../../../imsdk/api";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { User } from "../../../imsdk/db/t_user";
import { useNavigationToChatView2 } from "./chat-helper";
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { Platform, Text, TouchableOpacity, View } from "react-native";
import { white } from "../../assets/style/colors";
import { ChatDetailUser } from "./components/ChatDetailUser";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { ChatDetailProps, singleStyles } from "./ChatDetail";
import { useChatStore } from "../../store/ChatStore";
import {
  Str_ChatTop,
  Str_ClearChatHistory,
  Str_MsgNotification,
  Str_OperationFailed,
  Str_Report,
  Str_SearchChatContent,
} from "../../language/string_res";
import time from "../../../imsdk/time";
import { showToast } from "../../components/Toast";
import { useIsFocused } from "@react-navigation/native";
import { CleanHistoryModal } from "./CleanHistoryModal";
import { CreateGroupModal } from "./CreateGroupModal";
import AddIcon from "../../assets/svg/icon_add_user.svg";
import globalEventBus from "../../utils/EventBus";
import { SystemTopic } from "./CListItem";
type SingleChatDetailState = {
  visible: boolean;
  cleanVisible: boolean;
  isMute: boolean;
  isTop: boolean;
};

export const SingleChatDetail = ({ navigation }: ChatDetailProps) => {
  const im = ImSdk.getInstance();
  const { chatState, chatDispatch } = useChatStore();
  const topicWithSummary = chatState.curTopicWithSummary;
  const chat = topicWithSummary.topic;
  const toChatView = useNavigationToChatView2();
  const [topUser, setTopUser] = useState<User>();
  const [detailState, setDetailState] = useState<SingleChatDetailState>({
    visible: false,
    cleanVisible: false,
    isMute: chat.mute,
    isTop: chat.order > 0,
  });
  const isForcus = useIsFocused();
  useEffect(() => {
    if (isForcus && chat?.uid) {
      im.GetUser(chat.uid).then((res) => {
        if (res.user) {
          setTopUser(res.user);
        }
      });
    }
  }, [chat?.uid, isForcus]);

  const users = useMemo(
    () => chat.tid.split("_").slice(-2).map(Number),
    [topicWithSummary]
  );

  const setIsTop = useCallback(
    (isTop: boolean) => {
      setDetailState((prev) => ({ ...prev, isTop: isTop }));
      topicWithSummary.topic.order = isTop ? 1 : 0;
      chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
    },
    [topicWithSummary, chatDispatch]
  );

  const setIsMute = useCallback(
    (isMute: boolean) => {
      setDetailState((prev) => ({ ...prev, isMute: isMute }));
      topicWithSummary.topic.mute = isMute;
      chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
    },
    [topicWithSummary, chatDispatch]
  );

  const handleTopChange = useCallback(
    (newValue: boolean) => {
      // Update UI state immediately for responsive feedback
      setDetailState((prev) => ({ ...prev, isTop: newValue }));
      // Update topic state
      const t = time.toUnixMillSecond(time.now());
      const order = newValue ? t : 0;
      topicWithSummary.topic.order = order;
      chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
      // Call API to sync with server
      ImSdk.getInstance()
        .SetTopicProps({ tid: chat.tid, order: order })
        .then((res) => {
          if (res.error) {
            showToast(Str_OperationFailed);
            // Revert on error
            setDetailState((prev) => ({ ...prev, isTop: !newValue }));
            topicWithSummary.topic.order = !newValue ? t : 0;
            chatDispatch({
              type: "CHAT_UPDATE_TOPIC",
              payload: topicWithSummary,
            });
          }
        });
    },
    [chat.tid, topicWithSummary, chatDispatch]
  );

  const handleMuteChange = useCallback(
    (newValue: boolean) => {
      // Update UI state immediately for responsive feedback
      setDetailState((prev) => ({ ...prev, isMute: newValue }));
      // Update topic state
      topicWithSummary.topic.mute = newValue;
      chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
      // Call API to sync with server
      ImSdk.getInstance()
        .SetTopicProps({ tid: chat.tid, mute: newValue })
        .then((res) => {
          if (res.error) {
            showToast(Str_OperationFailed);
            // Revert on error
            setDetailState((prev) => ({ ...prev, isMute: !newValue }));
            topicWithSummary.topic.mute = !newValue;
            chatDispatch({
              type: "CHAT_UPDATE_TOPIC",
              payload: topicWithSummary,
            });
          }
        });
    },
    [chat.tid, topicWithSummary, chatDispatch]
  );

  const setCleanVisible = useCallback(
    (vis: boolean) => {
      setDetailState({ ...detailState, cleanVisible: vis });
    },
    [detailState]
  );

  function handleSubmit(topic: TopicWithSummary) {
    toChatView(topic).then(() => {});
  }

  if (!topUser) {
    return <></>;
  }

  const isSystemChat = () => {
    return users.includes(SystemTopic.Assistant) || users.includes(SystemTopic.Collect) || users.includes(SystemTopic.Notification);
  }

  return (
    <View style={{ flex: 1, backgroundColor: white }}>
      {/* 聊天详情标题栏 */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 15,
          borderBottomWidth: 1,
          borderBottomColor: "#f0f0f0",
          backgroundColor: white,
        }}
      >
        <Text
          style={{ flex: 1, fontSize: 18, fontWeight: "bold", color: "#333" }}
        >
          聊天详情
        </Text>
        <TouchableOpacity
          onPress={() => {
            // 在Web平台关闭侧边栏，在移动端返回
            if (Platform.OS === "web") {
              // 触发关闭侧边栏事件
              globalEventBus.emit("ShowWebDetail", { screenName: "ChatList" });
            } else {
              navigation.goBack();
            }
          }}
          style={{ padding: 5 }}
        >
          <Text style={{ fontSize: 28, color: "#666", lineHeight: 28 }}>×</Text>
        </TouchableOpacity>
      </View>
      {!isSystemChat() && (
        <View
          style={{
            flexDirection: "row",
            backgroundColor: white,
            margin: 10,
          }}
        >
          <ChatDetailUser
            user={topUser}
            action={() =>
              navigation.navigate("ContactInfoModeal", { current: topUser })
            }
          />
          <TouchableOpacity
            style={singleStyles.add}
            onPress={() => setDetailState({ ...detailState, visible: true })}
          >
            <AddIcon width={50} height={50} />
          </TouchableOpacity>
        </View>
      )}
      <CommonSetting
        style={{ borderRadius: 0 }}
        itemOption={[
          {
            text: Str_SearchChatContent,
            rightType: "Back",
            onClick: () =>
              navigation.navigate("SearchChatResultScreen", { tid: chat.tid }),
          },
          {
            text: Str_ChatTop,
            rightType: "Switch",
            switchIsEnabled: detailState.isTop,
            setIsEnabled: setIsTop,
            switchChange: handleTopChange,
          },
          {
            text: Str_MsgNotification,
            rightType: "Switch",
            switchIsEnabled: detailState.isMute,
            setIsEnabled: setIsMute,
            switchChange: handleMuteChange,
          },
          {
            text: Str_ClearChatHistory,
            rightType: "Back",
            onClick: () =>
              setDetailState({ ...detailState, cleanVisible: true }),
          },
          {
            text: Str_Report,
            rightType: "Back",
            visible: !isSystemChat(),
            onClick: () => {
              navigation.navigate("Report", { tid: chat.tid });
            },
          },
        ]}
      />
      <CreateGroupModal
        users={users}
        visible={detailState.visible}
        updateVisible={(vis) =>
          setDetailState({ ...detailState, visible: vis })
        }
        onClose={() => setDetailState({ ...detailState, visible: false })}
        onSubmit={handleSubmit}
      />
      <CleanHistoryModal
        setVis={setCleanVisible}
        tid={chat.tid}
        vis={detailState.cleanVisible}
      />
    </View>
  );
};
